export const filtersActionCreator = {
    setFilter: (payload, type) => ({ type, payload }),
}